import React, { memo } from 'react'

const NodeTags: React.FC = () => {
  return <div className="node-tags">{/* Your tags content here */}</div>
}

export default memo(NodeTags)
